export default "__VITE_ASSET__BkltoEap__"